// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__xH3zg","rightAdornment":"Header_rightAdornment__1gcuN"};